import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from 'react-router-dom';
import { FaClipboardList, FaIdCard, FaTree, FaBarcode } from 'react-icons/fa';
import logo from './assets/logo3.png';
import './app.css';

import EmailProcessorTool from './EmailProcessorTool';
import CoitCards from './CoitCards';
import CSFCableCar from './CSFCableCar';
import BarcodeDashboard from './BarcodeDashboard';

function Header() {
  return (
    <header className="app-header">
      <div className="header-inner">
        <img src={logo} alt="Calitho Suite Logo" className="header-logo" />
        <nav className="header-nav">
          <Link to="/" className="nav-link">Home</Link>
        </nav>
        <button className="nav-toggle" aria-label="Toggle Menu">☰</button>
      </div>
    </header>
  );
}

function HomePage() {
  const tools = [
    { path: '/Atlassian-Orders-Processor', label: 'Atlassian Orders', icon: <FaClipboardList /> },
    { path: '/coit-cards',               label: 'Coit Cards',         icon: <FaIdCard /> },
    { path: '/cable-car-verification',   label: 'Cable Car',         icon: <FaTree /> },
    { path: '/barcode-planner',          label: 'Barcode Planner',   icon: <FaBarcode /> },
  ];

  return (
    <main className="home-page">
      <h1 className="home-title">Welcome to Calitho Suite</h1>
      <p className="home-subtitle">Select a tool below to get started:</p>
      <div className="tools-grid">
        {tools.map(tool => (
          <Link key={tool.path} to={tool.path} className="tool-card">
            <div className="tool-icon">{tool.icon}</div>
            <h2 className="tool-label">{tool.label}</h2>
          </Link>
        ))}
      </div>
    </main>
  );
}

function App() {
  return (
    <Router>
      <Header />
      <div className="main-container">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/Atlassian-Orders-Processor" element={<EmailProcessorTool />} />
          <Route path="/coit-cards" element={<CoitCards />} />
          <Route path="/cable-car-verification" element={<CSFCableCar />} />
          <Route path="/barcode-planner" element={<BarcodeDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
